module.exports = {
  menuBg: '#0F2027',
  menuText: '#A8B8C8',
  menuActiveText: '#74C69D'
}
